import { defineMessages } from 'react-intl';

const messages = defineMessages({
  close: {
    id: 'modal.close',
    defaultMessage: 'Close',
  },
});

export default messages;
